module.exports = __webpack_public_path__ + "static/lightning-datepicker-disabled-7cc6abf7ee30217171e4750fdafdd0bb.png";